import { BrazilianDocumentKind, CNPJ_LENGTH, CPF_LENGTH } from './types';

const DOCUMENT_PUNCTUATION = /[.\-\/\s()]/g;

/** Remove pontuação e padroniza letras para maiúsculas (CNPJ alfanumérico). */
export function normalizeBrazilianDocument(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  return String(value).normalize('NFKC').toUpperCase().replace(DOCUMENT_PUNCTUATION, '');
}

/** Identifica CPF vs CNPJ a partir do valor já normalizado ou formatado. */
export function detectBrazilianDocumentKind(value: string | null | undefined): BrazilianDocumentKind {
  const clean = normalizeBrazilianDocument(value);
  if (!clean) {
    return 'unknown';
  }
  if (/[A-Z]/.test(clean)) {
    return 'cnpj';
  }
  if (clean.length <= CPF_LENGTH) {
    return 'cpf';
  }
  if (clean.length <= CNPJ_LENGTH) {
    return 'cnpj';
  }
  return 'unknown';
}

export function isCpfDocument(value: string | null | undefined): boolean {
  const clean = normalizeBrazilianDocument(value);
  return /^\d{11}$/.test(clean);
}

export function isCnpjDocument(value: string | null | undefined): boolean {
  const clean = normalizeBrazilianDocument(value);
  return /^[0-9A-Z]{12}\d{2}$/.test(clean);
}
